import {Radio, Select} from "antd";
import {useProject} from "../Context/ProjectContext";
import {useEffect} from "react";
import {ArrowDownOutlined, ArrowUpOutlined, SortAscendingOutlined} from "@ant-design/icons";
import {AppActions, useAppContext} from "../Context/ProjectContextV2";


export default function CrossSectionFilter({csList = [], type}) {
    const {selectedOperation, selectedHistoryId, getSelectedHistory, dispatchProject, getCSList} = useAppContext()

    const renderCSList = (cs_list) => {
        return (cs_list || [])?.map(x => (
            <Select.Option key={x.name} value={x.name}>
                {x.name}
            </Select.Option>
        ))
    }

    return (
        <div style={{display: 'flex', alignItems: 'center'}}>
            <Select
                placeholder={'DS'}
                style={{width: 150}}
                size={'small'}
                value={getSelectedHistory()?.page?.filter?.ds}
                onChange={(val) => {
                    const page = {...getSelectedHistory()?.page}
                    page.filter.ds = val
                    dispatchProject({
                        type: AppActions.SET_PAGE_SETTINGS,
                        data: {page}
                    })
                }}
            >
                {
                    renderCSList([...getCSList()].filter((x, idx) => idx > 0)).reverse()
                }
            </Select>
            <Select
                placeholder={'US'}
                style={{width: 150}}
                size={'small'}
                value={getSelectedHistory()?.page?.filter?.us}
                onChange={(val) => {
                    const page = {...getSelectedHistory()?.page}
                    page.filter.us = val
                    dispatchProject({
                        type: AppActions.SET_PAGE_SETTINGS,
                        data: {page}
                    })
                }}
            >
                {
                    renderCSList([...getCSList()])
                }
            </Select>
            <Radio.Group
                options={[
                    {label: 'Color', value: 'highlight'},
                    {label: 'Filter', value: 'filter'},
                    {label: 'Clear', value: 'clear'},
                ]}
                onChange={(e) => {
                    const page = {...getSelectedHistory()?.page}

                    if(e.target.value === 'clear') {
                        page.filter.us = ''
                        page.filter.ds = ''
                        page.filter.type = 'clear'
                    }
                    else {
                        page.filter.type = e.target.value
                    }

                    dispatchProject({
                        type: AppActions.SET_PAGE_SETTINGS,
                        data: {page}
                    })
                }}
                value={getSelectedHistory()?.page?.filter?.type}
                optionType="button"
                buttonStyle="solid"
                size={'small'}
            />
        </div>
    )
}